import {FeatureAppDependencies} from '../../src';
import {useFeatureAppEnvironment} from './use-feature-app-environment';

export function useFeatureServices(): FeatureAppDependencies {
  const {featureServices} = useFeatureAppEnvironment();

  return featureServices;
}
